import { Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatInputModule } from '@angular/material/input';
import { AccountType } from '../../interfaces/account-type.interface';

@Component({
  selector: 'si-signup-declaration',
  standalone: true,
  imports: [ReactiveFormsModule, MatCheckboxModule, MatInputModule],
  templateUrl: './signup-declaration.component.html',
  styleUrl: './signup-declaration.component.scss'
})
export class SignupDeclarationComponent {
  @Input({ required: true }) formGroup: FormGroup;
  @Input() accountType: AccountType;

  get declarationText() {
    switch (this.accountType) {
      case AccountType.Sido:
        return `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce lobortis consequat leo eget pulvinar. Suspendisse id leo quis velit tempor dignissim. Fusce finibus egestas ante, quis finibus dolor facilisis sed. Aliquam erat volutpat. Aenean gravida tortor leo, eget venenatis sem congue et. Ut malesuada tempus urna non tincidunt. Fusce vestibulum nisl et sem ornare sodales at eu erat. Maecenas pharetra mattis sodales.`;

      case AccountType.PaOrMsp:
        return `Donec ac est at nulla scelerisque consectetur. Etiam varius eu massa et scelerisque. Etiam hendrerit pulvinar enim, porta fermentum velit sagittis ut. Mauris finibus nunc sit amet lacus viverra, at lobortis ligula ultricies.`;

      default:
        return '';
    }
  }
}
